import React from "react";
import { LuCheck } from "react-icons/lu";
import { cn } from "../../components/ui";
import { t } from "../../i18n";
import { STEP_KEYS } from "./appeal";

/** Progresso dos 7 passos: bolinhas no desktop, barra no celular e o nome do passo atual e do próximo. */
export const StepsProgress: React.FC<{ index: number }> = ({ index }) => {
  const total = STEP_KEYS.length;
  const next = STEP_KEYS[index + 1];
  return (
    <div className="flex flex-col gap-2.5">
      <div className="hidden items-center sm:flex" aria-hidden>
        {STEP_KEYS.map((key, i) => (
          <React.Fragment key={key}>
            {i > 0 && <span className={cn("h-0.5 flex-1 transition-colors duration-base", i <= index ? "bg-primary" : "bg-primary-line")} />}
            <span
              className={cn(
                "grid h-7 w-7 shrink-0 place-items-center rounded-full border-2 text-caption font-bold transition duration-base",
                i < index && "border-primary bg-primary text-on-primary",
                i === index && "border-primary bg-surface text-primary shadow-focus",
                i > index && "border-primary-line bg-surface text-fg-subtle"
              )}
            >
              {i < index ? <LuCheck size={14} strokeWidth={3} /> : i + 1}
            </span>
          </React.Fragment>
        ))}
      </div>
      <div className="h-1.5 overflow-hidden rounded-full bg-primary-tint sm:hidden" aria-hidden>
        <i className="block h-full rounded-full bg-primary transition-all duration-base" style={{ width: `${((index + 1) / total) * 100}%` }} />
      </div>
      <p className="flex justify-between gap-2.5 text-caption text-fg-muted">
        <span>
          {t("appeals.progress", { step: index + 1, total })}
          <strong className="text-primary">{t(`appeals.steps.${STEP_KEYS[index]}`)}</strong>
        </span>
        {next && <span className="hidden min-[400px]:inline">{t("appeals.next", { label: t(`appeals.steps.${next}`) })}</span>}
      </p>
    </div>
  );
};
